(() => {
  if (window.__kkInvZeroInit) return;
  window.__kkInvZeroInit = true;
  console.log('KK InvZero: init');

  const parseNumber = (txt) => {
    if (!txt) return NaN;
    const m = String(txt).trim().match(/(\d+)/);
    return m ? parseInt(m[1], 10) : NaN;
  };

  const findRoot = (node) =>
    node.closest('.product-inventory-notice--wrapper, .product-inventory-notice') || node;

  const setZeroClass = (root, isZero) => {
    if (!root) return;
    root.classList.toggle('kk-inventory-zero', isZero);
    if (isZero) {
      root.setAttribute('data-kk-inventory-zero', '1');
    } else {
      root.removeAttribute('data-kk-inventory-zero');
    }
  };

  const scan = () => {
    document.querySelectorAll('.product-inventory-notice, .product-inventory-notice--wrapper')
      .forEach(root => {
        let isZero = false;

        // A) Zahl im Text prüfen
        const textEl = root.querySelector('.product-inventory-notice--text');
        if (textEl) {
          const n = parseNumber(textEl.textContent);
          if (!Number.isNaN(n)) {
            isZero = (n === 0);
          }
        }

        // B) CSS-Variable --inventory-scale auswerten
        if (!isZero) {
          const barEl = root.querySelector('.product-inventory-notice--bar');
          if (barEl) {
            const scale = barEl.style.getPropertyValue('--inventory-scale');
            if (scale && parseFloat(scale) === 0) {
              isZero = true;
            }
          }
        }

        setZeroClass(root, isZero);
      });
  };

  // Initial + kleine Verzögerung, falls lazy gerendert
  scan();
  setTimeout(scan, 100);
  setTimeout(scan, 300);

  // Änderungen beobachten (Variant-Wechsel etc.)
  const mo = new MutationObserver(scan);
  mo.observe(document.body, { subtree: true, childList: true, characterData: true });

  document.addEventListener('shopify:section:load', scan);
  document.addEventListener('variant:changed', scan);
})();